import { AfterViewInit, Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimeFormatStyle } from '@grupo-constant/next-dtype/types';
import { NgbTimeAdapter, NgbTimepicker, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'timepicker-autofill-component',
    templateUrl: './timepicker-autofill.component.html',
    providers: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, NgbTimepickerModule, ReactiveFormsModule]
})
export class TimepickerAutofillComponent implements OnInit, AfterViewInit{
    @ViewChild('timepicker') timepicker: NgbTimepicker;

    @Input() control: FormControl;

    @Input() min: string;
    @Input() max: string;
    @Input() style: TimeFormatStyle;
    @Input() allowManual: boolean;
    @Input() hourStep: number;
    @Input() minuteStep: number;
    @Input() secondStep: number;
    @Input() spinners: boolean = true;


    constructor(private ngbTimeAdapter: NgbTimeAdapter<string>) { }

    ngOnInit() {
        if (!this.style) {
            this.style = TimeFormatStyle.HHMMSS;
        }
        if (!this.hourStep) {
            this.hourStep = 1;
        }
        if (!this.minuteStep) {
            this.minuteStep = 1;
        }
        if (!this.secondStep && this.style === TimeFormatStyle.HHMMSS) {
            this.secondStep = 1;
        }
    }

    ngAfterViewInit(): void {
        this.timepicker.updateHour = (newVal: string): void => {
            const isPM = this.timepicker.model.hour >= 12;
            const enteredHour = newVal ? Number(newVal) : undefined;
            if (this.timepicker.meridian && (isPM && enteredHour < 12 || !isPM && enteredHour === 12)) {
                this.timepicker.model.updateHour(enteredHour + 12);
            } else {
                this.timepicker.model.updateHour(enteredHour);
            }
            this.updateTimes();
        };

        this.timepicker.changeHour = (step: number): void => {
            this.timepicker.model.changeHour(step);
            this.updateTimes();
        };

        this.timepicker.updateMinute = (newVal: string): void => {
            const enteredMinute = newVal ? Number(newVal) : undefined;
            this.timepicker.model.updateMinute(enteredMinute);
            this.updateTimes();
        };

        this.timepicker.changeMinute = (step: number): void => {
            this.timepicker.model.changeMinute(step);
            this.updateTimes();
        };

        this.timepicker.updateSecond = (newVal: string): void => {
            const enteredSecond = newVal ? Number(newVal) : undefined;
            this.timepicker.model.updateSecond(enteredSecond);
            this.updateTimes();
        };

        this.timepicker.changeSecond = (step: number): void => {
            this.timepicker.model.changeSecond(step);
            this.updateTimes();
        };
    }

    updateTimes() {
        if ((this.timepicker.model.minute === undefined || isNaN(this.timepicker.model.minute))
            && (this.timepicker.model.hour !== undefined && !isNaN(this.timepicker.model.hour))) {
            this.timepicker.model.updateMinute(0);
        }
        if ((this.timepicker.model.second === undefined || isNaN(this.timepicker.model.second))) {
            this.timepicker.model.updateSecond(0);
        }
        if (this.timepicker.model.isValid(this.timepicker.seconds)) {
            this.timepicker.onChange(this.ngbTimeAdapter.toModel({
                hour: this.timepicker.model.hour,
                minute: this.timepicker.model.minute,
                second: this.timepicker.model.second
            }));
        } else {
            this.timepicker.onChange(this.ngbTimeAdapter.toModel(null));
        }
    }
}
